export function parsePositiveIntegerId(value) {
  const normalized = String(value ?? '').trim()
  if (!/^[1-9]\d*$/.test(normalized)) return null

  const id = Number(normalized)
  return Number.isSafeInteger(id) ? id : null
}

export function isValidDateRange(startDate, endDate) {
  if (!startDate || !endDate) return true
  return String(startDate) <= String(endDate)
}

export function isValidDeadlineTime(value) {
  if (value === undefined || value === null || value === '') return true
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(String(value))
}
